export const quickAnswer =
  'Find a code, follow a sequence, or check a machine pattern. Start with the six Secret Hideouts below.';

## Six Secret Hideouts

Each guide starts with the input you need. Restaurant names repeat across zones, so check the location before using a solution.

## How to Use These Puzzle Solutions

Open the matching guide for an original diagram, location notes and troubleshooting. Follow numbered steps in order; machine-state puzzles instead require the final configuration.
